import type { PurchaseMarketService } from './PurchaseMarketContext'

/**
 * Creates a static purchase market service that returns
 * pre-fetched data. Used in read-only mode (public app).
 */
export const createStaticPurchaseMarketService = (
  marketAggregations: any
): PurchaseMarketService => {
  const data = marketAggregations?.purchase || {}

  return {
    getPriceEvolutionData: async (filters?: any) => ({
      aggregations:
        filters?.price_field === 'price_per_square_meter'
          ? data.priceEvolutionPerSqm || {}
          : data.priceEvolution || {},
    }),
    getNewVsResaleData: async () => ({
      aggregations: data.newVsResale || {},
    }),
    getPricePerRoomData: async () => ({
      aggregations: data.pricePerRoom || {},
    }),
    getPriceM2PerRoomData: async () => ({
      aggregations: data.priceM2PerRoom || {},
    }),
    getDistributionData: async () => ({
      aggregations: data.distribution || {},
    }),
  }
}
